module.exports = __webpack_public_path__ + "static/media/profile_pic.27a1fe10.svg";